/**
 * ResizeHoc 自适应高阶组件
 * 
 * 自动监听容器尺寸变化，传递计算后的宽高给子组件
 */
import React, { memo, cloneElement, useRef } from 'react';
import { Spin } from 'antd';
import useResize from '../../../hooks/useResize';

import './style.scss';

export interface ResizeHocProps {
  children: React.ReactElement<{
    ratio?: number;
    minWidth?: number;
    minHeight?: number;
    maxHeight?: number;
    getMinWidthFunc?: () => number;
    loading?: boolean;
    width?: number;
    height?: number;
    onAfterRender?: () => void;
  }>;
}

const ResizeHoc = memo<ResizeHocProps>(({ children }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  
  const { rect, isLoading, setLoading } = useResize(containerRef, {
    ratio: children?.props?.ratio,
    minWidth: children?.props?.minWidth,
    minHeight: children?.props?.minHeight,
    maxHeight: children?.props?.maxHeight,
    getMinWidthFunc: children?.props?.getMinWidthFunc,
  });

  const handleAfterPaint = () => setTimeout(() => setLoading(false), 1000);

  const loading = children?.props?.hasOwnProperty('loading') 
    ? !!children?.props?.loading 
    : isLoading;

  const nextChildProps = {
    ...children.props,
    loading,
    width: children?.props?.width || rect.width,
    height: children?.props?.height || rect.height,
    onAfterRender: handleAfterPaint,
  };

  const cloneNode = cloneElement(children, { ...nextChildProps });

  return (
    <div ref={containerRef} className="music-resize-hoc">
      <Spin spinning={loading}>{cloneNode}</Spin>
    </div>
  );
});

ResizeHoc.displayName = 'ResizeHoc';

export default ResizeHoc;
